/**
 * 에러 바운더리에서 잡은 렌더링 에러를 Datadog RUM에 보고한다.
 * source(파일명)를 에러 name으로 지정해 RUM Error Tracking에서 발생 위치를 구분한다.
 * @link https://docs.datadoghq.com/real_user_monitoring/browser/collecting_browser_errors/?tab=npm#react-error-boundaries-instrumentation
 */
export const addRenderingErrorToRum = ({
  error,
  source,
}: {
  error: Error;
  source: string;
}): void => {
  import('@datadog/browser-rum')
    .then(({ datadogRum }) => {
      const renderingError = new Error(error.message);
      renderingError.name = source;
      renderingError.cause = error;

      datadogRum.addError(renderingError);
    })
    .catch((importError) => {
      console.error('Datadog RUM 에러 로깅 실패:', importError);
    });
};
